import  { createContext } from 'react';

export interface FeatureFlagContextType {
  /**
   * Returns true if the flag is enabled (i.e. its variant value is 'on').
   */
  isFeatureEnabled: (flag: string) => boolean;
  /**
   * Refreshes the experiment state (if needed).
   */
  refreshFlags: () => Promise<void>;
  /**
   * Indicates if the experiment is still loading.
   */
  loading: boolean;
}

export const FeatureFlagContext = createContext<FeatureFlagContextType>({
  isFeatureEnabled: (_: string) => false,
  refreshFlags: async () => {
    // do nothing
  },
  loading: true,
});
